import {
    componentService,
    Component,
    requestService,
    element as $,
    LocalStorage,
} from '@contorion/core';

const LOCAL_STORAGE_KEY = 'productHistories';
const SELECTOR_ITEMS_CONTENT = '.js-product-history__content';
const SELECTOR_ITEMS_ERASE = '.js-product-history__erase';
const CLASS_HIDDEN: string = 'hidden';

export class ProductHistoryComponent extends Component {
    protected localStorage: LocalStorage = new LocalStorage();

    protected get url(): string {
        const historySkus = this.historySkus.join(',');

        return `${this.element.dataset.url}-${historySkus}?type=html&template=productHistory`;
    }

    protected get sku(): string {
        return this.element.dataset.sku;
    }

    protected get contentWrapper(): HTMLElement {
        return <HTMLElement> $(SELECTOR_ITEMS_CONTENT, this.element);
    }

    protected get eraseItemsButton(): HTMLElement {
        return <HTMLElement> $(SELECTOR_ITEMS_ERASE, this.element);
    }

    protected get historySkus(): Array<string> {
        const historySkus = this.localStorage.getValue(LOCAL_STORAGE_KEY);

        return historySkus ? JSON.parse(historySkus) : [];
    }

    protected set historySkus(updatedSkuHistory: Array<string>) {
        this.localStorage.setValue(LOCAL_STORAGE_KEY, JSON.stringify(updatedSkuHistory));
    }

    constructor(protected element: HTMLElement) {
        super(element);
        this.init();
    }

    protected async init(): Promise<void> {
        if (this.historySkus.length > 0) {
            await this.loadContent();
            this.bindEvents();
        }

        this.addSkuToHistory(this.sku);
    }

    protected bindEvents(): void {
        this.eraseItemsButton.addEventListener('click', this.onErase.bind(this));
    }

    protected addSkuToHistory(sku: string): void {
        const oldSkus = this.historySkus;

        if (sku === '' || oldSkus.indexOf(sku) !== -1) {
            return;
        }

        if (oldSkus.length > 39) {
            oldSkus.pop();
        }

        this.historySkus = [sku, ...oldSkus];
    }

    protected onErase(e: Event) {
        e.preventDefault();
        this.element.innerHTML = '';
        this.localStorage.removeValue(LOCAL_STORAGE_KEY);
    }

    protected async loadContent(): Promise<void> {
        this.contentWrapper.innerHTML = await requestService.get(this.url)
            .then((response: Response) => response.text());
        this.element.classList.remove(CLASS_HIDDEN);
        componentService.load(this.element);
    }
}
